// extracted by mini-css-extract-plugin
export default {"list":"QueryGuide_list__fmJJS"};